<template>
  <div class="ff">
    <div class="infile">
      <label for="filesasd">{{ fileName || urlName || "Выбрать" }}</label>
      <input type="file" id="filesasd" @change="fileChange" />
    </div>

    <a
      :href="url"
      target="_blank"
      type="button"
      class="btn btn-sm btn-success"
      :class="{ disabled: urlName == '' || newPdf }"
      >Посмотреть</a
    >
  </div>
</template>

<script>
export default {
  name: "Fileinput",
  props: {
    url: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      fileName: "",
      newPdf: false,
    };
  },
  computed: {
    urlName() {
      if (this.url != "") {
        return this.url.substring(this.url.length - 10, this.url.length);
      } else return "";
    },
  },
  methods: {
    fileChange(e) {
      let file = e.target.files[0];

      if (file && file.type == "application/pdf") {
        let t = file.name;
        if (t.length > 11)
          this.fileName = "." + t.substring(t.length - 11, t.length);
        else this.fileName = t;
        this.newPdf = true;
        this.$emit("isFile", file);
      } else {
        this.fileName = this.urlName;
        e.target.value = null;
        this.newPdf = false;
        this.$emit("isFile", null);
      }

      console.log(e.target.files[0]);
    },
  },
};
</script>

<style lang="scss" scoped>
.ff {
  position: relative;

  .infile {
    label {
      display: block;
      overflow: hidden;
      width: 100%;
      max-width: 120px;
      background-color: #3f87f5;
      border-color: #3f87f5;
      color: #fff;
      padding: 0.35rem 1rem;
      height: auto;
      cursor: pointer;
      display: inline-block;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 1.25;
      text-align: center;
      border-radius: 0.2rem;
      transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
        border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      &:hover,
      &:focus {
        color: #fff;
        background-color: #5796f6;
        border-color: #5796f6;
      }
    }
  }
  #filesasd {
    position: absolute;
    width: 0.1px;
    height: 0.1px;
    z-index: -1;
    opacity: 0;
  }
  button {
    display: block;
    width: 100%;
  }
}
</style>
